import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const TOGGLE_STYLE = {
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
  width: 'fit-content', margin: '12px auto 0', padding: '8px 24px',
  background: 'var(--primary)', border: '1.5px solid var(--primary)',
  borderRadius: '20px', color: '#fff',
  cursor: 'pointer', fontSize: '13px', fontWeight: '600',
};

const RoomBlock = (props) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const children = React.Children.toArray(props.children);
  const firstChild = children[0];
  const restChildren = children.slice(1);
  const hasMore = restChildren.length > 0;

  return (
    <div className="card mb-4 room-info">
      <div className="card-body roomPlans">
        {firstChild}
        {hasMore && (
          <>
            <button
              type="button"
              style={TOGGLE_STYLE}
              onClick={() => setExpanded(e => !e)}
            >
              <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} />
              {expanded
                ? t('labels.hideMoreOffers')
                : t('labels.showMoreOffers', { count: restChildren.length })}
            </button>
            {expanded && restChildren}
          </>
        )}
      </div>
    </div>
  );
};

export default RoomBlock;
